import { TranslatedText, TranslatedTextList } from "Store/texts/interfaces";

import { InsuranceType } from "Components/Features/CheckPrice/Products/productTypes";

export enum AccidentCoverage {
  ACCIDENT_DEATH = "ACCIDENT_DEATH",
  ACCIDENT_DISABLEMENT = "ACCIDENT_DISABLEMENT",
}

export enum AkaChildCoverage {
  AKA_CHILD_STANDARD = "AKA_CHILD_STANDARD",
}

export enum AkaCriticalIllness {
  AKA_CRITICAL_ILLNESS = "AKA_CRITICAL_ILLNESS",
  AKA_CRITICAL_ILLNESS_CO_INSURED = "AKA_CRITICAL_ILLNESS_CO_INSURED",
  AKA_CRITICAL_ILLNESS_MEMBER_AND_CO_INSURED = "AKA_CRITICAL_ILLNESS_MEMBER_AND_CO_INSURED",
}

export enum AkaFamilyAccidentCoverage {
  AKA_FAMILY_ACCIDENT_DEATH = "AKA_FAMILY_ACCIDENT_DEATH",
  AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY = "AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY",
  AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY_AND_PROFESSIONAL_DISABILITY = "AKA_FAMILY_ACCIDENT_DEATH_AND_DISABILITY_AND_PROFESSIONAL_DISABILITY",
  AKA_FAMILY_ACCIDENT_DISABILITY = "AKA_FAMILY_ACCIDENT_DISABILITY",
  AKA_FAMILY_ACCIDENT_DISABILITY_AND_PROFESSIONAL_DISABILITY = "AKA_FAMILY_ACCIDENT_DISABILITY_AND_PROFESSIONAL_DISABILITY",
}

export enum AkaGroupLifeCompositions {
  AKA_GROUP_LIFE_INSURED_DEATH = "AKA_GROUP_LIFE_INSURED_DEATH",
  AKA_GROUP_LIFE_INSURED_INCAPACITY_OF_WORK = "AKA_GROUP_LIFE_INSURED_INCAPACITY_OF_WORK",
  AKA_GROUP_LIFE_INSURED_TIME_LIMITED_DISABILITY_INTEREST = "AKA_GROUP_LIFE_INSURED_TIME_LIMITED_DISABILITY_INTEREST",
  AKA_GROUP_LIFE_CO_INSURED_DEATH = "AKA_GROUP_LIFE_CO_INSURED_DEATH",
  AKA_GROUP_LIFE_CO_INSURED_INCAPACITY_OF_WORK = "AKA_GROUP_LIFE_CO_INSURED_INCAPACITY_OF_WORK",
  AKA_GROUP_LIFE_CO_INSURED_TIME_LIMITED_DISABILITY_INTEREST = "AKA_GROUP_LIFE_CO_INSURED_TIME_LIMITED_DISABILITY_INTEREST",
}

export const AKA_GROUP_LIFE_DISABILITY_COMPOSITES = [
  AkaGroupLifeCompositions.AKA_GROUP_LIFE_INSURED_INCAPACITY_OF_WORK,
  AkaGroupLifeCompositions.AKA_GROUP_LIFE_INSURED_TIME_LIMITED_DISABILITY_INTEREST,
  AkaGroupLifeCompositions.AKA_GROUP_LIFE_CO_INSURED_INCAPACITY_OF_WORK,
  AkaGroupLifeCompositions.AKA_GROUP_LIFE_CO_INSURED_TIME_LIMITED_DISABILITY_INTEREST,
];

export enum AkaGroupLifeCoverage {
  AKA_GROUP_LIFE_ALL = "AKA_GROUP_LIFE_ALL",
  AKA_GROUP_LIFE_ALL_AND_CO_ALL = "AKA_GROUP_LIFE_ALL_AND_CO_ALL",
  AKA_GROUP_LIFE_ALL_AND_CO_DEATH = "AKA_GROUP_LIFE_ALL_AND_CO_DEATH",
  AKA_GROUP_LIFE_ALL_AND_CO_INCAP = "AKA_GROUP_LIFE_ALL_AND_CO_INCAP",
  AKA_GROUP_LIFE_ALL_AND_CO_DEATH_AND_INCAP = "AKA_GROUP_LIFE_ALL_AND_CO_DEATH_AND_INCAP",
  AKA_GROUP_LIFE_ALL_AND_CO_INCAP_AND_TIME = "AKA_GROUP_LIFE_ALL_AND_CO_INCAP_AND_TIME",
  AKA_GROUP_LIFE_ALL_CO = "AKA_GROUP_LIFE_ALL_CO",
  AKA_GROUP_LIFE_DEATH = "AKA_GROUP_LIFE_DEATH",
  AKA_GROUP_LIFE_DEATH_AND_CO_ALL = "AKA_GROUP_LIFE_DEATH_AND_CO_ALL",
  AKA_GROUP_LIFE_DEATH_AND_CO_DEATH = "AKA_GROUP_LIFE_DEATH_AND_CO_DEATH",
  AKA_GROUP_LIFE_DEATH_AND_CO_DEATH_AND_INCAP = "AKA_GROUP_LIFE_DEATH_AND_CO_DEATH_AND_INCAP",
  AKA_GROUP_LIFE_DEATH_AND_CO_INCAP = "AKA_GROUP_LIFE_DEATH_AND_CO_INCAP",
  AKA_GROUP_LIFE_DEATH_AND_CO_INCAP_AND_TIME = "AKA_GROUP_LIFE_DEATH_AND_CO_INCAP_AND_TIME",
  AKA_GROUP_LIFE_DEATH_AND_INCAP = "AKA_GROUP_LIFE_DEATH_AND_INCAP",
  AKA_GROUP_LIFE_DEATH_AND_INCAP_CO = "AKA_GROUP_LIFE_DEATH_AND_INCAP_CO",
  AKA_GROUP_LIFE_DEATH_CO = "AKA_GROUP_LIFE_DEATH_CO",
  AKA_GROUP_LIFE_INCAP = "AKA_GROUP_LIFE_INCAP",
  AKA_GROUP_LIFE_INCAP_AND_CO_DEATH = "AKA_GROUP_LIFE_INCAP_AND_CO_DEATH",
  AKA_GROUP_LIFE_INCAP_AND_CO_DEATH_AND_INCAP = "AKA_GROUP_LIFE_INCAP_AND_CO_DEATH_AND_INCAP",
  AKA_GROUP_LIFE_INCAP_AND_CO_INCAP = "AKA_GROUP_LIFE_INCAP_AND_CO_INCAP",
  AKA_GROUP_LIFE_INCAP_AND_CO_INCAP_AND_TIME = "AKA_GROUP_LIFE_INCAP_AND_CO_INCAP_AND_TIME",
  AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_ALL = "AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_ALL",
  AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_DEATH = "AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_DEATH",
  AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_DEATH_AND_INCAP = "AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_DEATH_AND_INCAP",
  AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_INCAP = "AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_INCAP",
  AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_INCAP_AND_TIME = "AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_INCAP_AND_TIME",
  AKA_GROUP_LIFE_INCAP_AND_TIME = "AKA_GROUP_LIFE_INCAP_AND_TIME",
  AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_ALL = "AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_ALL",
  AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_DEATH = "AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_DEATH",
  AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_DEATH_AND_INCAP = "AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_DEATH_AND_INCAP",
  AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_INCAP = "AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_INCAP",
  AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_INCAP_AND_TIME = "AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_INCAP_AND_TIME",
  AKA_GROUP_LIFE_INCAP_AND_TIME_CO = "AKA_GROUP_LIFE_INCAP_AND_TIME_CO",
  AKA_GROUP_LIFE_INCAP_CO = "AKA_GROUP_LIFE_INCAP_CO",
  AKA_GROUP_LIFE_INCAP_AND_CO_ALL = "AKA_GROUP_LIFE_INCAP_AND_CO_ALL",
}

export const AKA_GROUP_LIFE_COVERAGES = [
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_ALL,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_DEATH,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_DEATH_AND_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_AND_CO_INCAP_AND_TIME,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_ALL_CO,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_ALL,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_DEATH,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_DEATH_AND_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_CO_INCAP_AND_TIME,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_AND_INCAP_CO,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_DEATH_CO,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_DEATH,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_DEATH_AND_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_INCAP_AND_TIME,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_ALL,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_DEATH,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_DEATH_AND_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_DEATH_AND_CO_INCAP_AND_TIME,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_ALL,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_DEATH,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_DEATH_AND_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_INCAP,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_AND_CO_INCAP_AND_TIME,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_TIME_CO,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_CO,
  AkaGroupLifeCoverage.AKA_GROUP_LIFE_INCAP_AND_CO_ALL,
];

export enum AkaHealthCoverage {
  AKA_HEALTH_CO_INSURED = "AKA_HEALTH_CO_INSURED",
  AKA_HEALTH_MEMBER = "AKA_HEALTH_MEMBER",
  AKA_HEALTH_MEMBER_AND_CO_INSURED = "AKA_HEALTH_MEMBER_AND_CO_INSURED",
}

export enum AkaHouseContentsCoverage {
  AKA_HOUSE_CONTENTS_STANDARD = "AKA_HOUSE_CONTENTS_STANDARD",
}

export enum AkaStudentCoverage {
  AKA_STUDENT_ABROAD_AUS = "AKA_STUDENT_ABROAD_AUS",
  AKA_STUDENT_ABROAD_EU = "AKA_STUDENT_ABROAD_EU",
  AKA_STUDENT_ABROAD_NOR = "AKA_STUDENT_ABROAD_NOR",
  AKA_STUDENT_ABROAD_OTHER = "AKA_STUDENT_ABROAD_OTHER",
  AKA_STUDENT_ABROAD_USA = "AKA_STUDENT_ABROAD_USA",
  AKA_STUDENT_STANDARD = "AKA_STUDENT_STANDARD",
}

export enum AkaTravelCoverage {
  AKA_TRAVEL_FOR_FAMILY = "AKA_TRAVEL_FOR_FAMILY",
  AKA_TRAVEL_FOR_INSURED_ONLY = "AKA_TRAVEL_FOR_INSURED_ONLY",
}

export enum AnimalCoverageGroup {
  ANIMAL_DEATH = "ANIMAL_DEATH",
  ANIMAL_VETERINARY = "ANIMAL_VETERINARY",
  ANIMAL_DEATH_AND_VETERINARY = "ANIMAL_DEATH_AND_VETERINARY",
}

export enum AnimalCoverage {
  DOG_DEATH_AND_INSURANCE_VALUE = "DOG_DEATH_AND_INSURANCE_VALUE",
  DOG_VET = "DOG_VET",
  DOG_DEATH_AND_VETERINARY = "DOG_DEATH_AND_VETERINARY",
  CAT_DEATH = "CAT_DEATH",
  CAT_VET = "CAT_VET",
  CAT_DEATH_AND_VETERINARY = "CAT_DEATH_AND_VETERINARY",
}

export enum BoatCoverage {
  BOAT_MOTOR_FULL_OWN_DAMAGE = "BOAT_MOTOR_FULL_OWN_DAMAGE",
  BOAT_MOTOR_FULL_OWN_DAMAGE_EXTENDED = "BOAT_MOTOR_FULL_OWN_DAMAGE_EXTENDED",
  BOAT_MOTOR_REDUCED_OWN_DAMAGE = "BOAT_MOTOR_REDUCED_OWN_DAMAGE",
  BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE = "BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE",
  BOAT_ROWBOAT_CANOE_KAYAK_REDUCED_OWN_DAMAGE = "BOAT_ROWBOAT_CANOE_KAYAK_REDUCED_OWN_DAMAGE",
  BOAT_SAILING_BOAT_FULL_OWN_DAMAGE = "BOAT_SAILING_BOAT_FULL_OWN_DAMAGE",
  BOAT_SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED = "BOAT_SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED",
  BOAT_SAILING_BOAT_REDUCED_OWN_DAMAGE = "BOAT_SAILING_BOAT_REDUCED_OWN_DAMAGE",
}

export enum CabinCoverage {
  CABIN_EXTENDED = "CABIN_EXTENDED",
  CABIN_STANDARD = "CABIN_STANDARD",
}

export enum CabinContentsCoverage {
  CABIN_CONTENTS_STANDARD = "CABIN_CONTENTS_STANDARD",
  CABIN_CONTENTS_EXTENDED = "CABIN_CONTENTS_EXTENDED",
}

export enum CarCoverage {
  AUTO_DRIVER_AND_PASSENGER_ACCIDENT = "AUTO_DRIVER_AND_PASSENGER_ACCIDENT", // Ansvar
  AUTO_FULL_OWN_DAMAGE = "AUTO_FULL_OWN_DAMAGE", // Kasko
  AUTO_FULL_OWN_DAMAGE_INCLUDING_RENTALCAR = "AUTO_FULL_OWN_DAMAGE_INCLUDING_RENTALCAR", // Med leiebil
  AUTO_FULL_SUPER_V2 = "AUTO_FULL_SUPER_V2", // Uten leiebil
  AUTO_FULL_SUPER_V2_INCLUDING_RENTALCAR = "AUTO_FULL_SUPER_V2_INCLUDING_RENTALCAR", // Med leiebil
  AUTO_FULL_SUPER = "AUTO_FULL_SUPER", // Super
  AUTO_REDUCED_OWN_DAMAGE = "AUTO_REDUCED_OWN_DAMAGE", // Delkasko
}

export const RENTAL_CAR_COVERAGES = [
  CarCoverage.AUTO_FULL_OWN_DAMAGE,
  CarCoverage.AUTO_FULL_OWN_DAMAGE_INCLUDING_RENTALCAR,
  CarCoverage.AUTO_FULL_SUPER_V2,
  CarCoverage.AUTO_FULL_SUPER_V2_INCLUDING_RENTALCAR,
  CarCoverage.AUTO_FULL_SUPER,
];

export enum CaravanCoverage {
  SERVICES = "__services",
  CARAVAN_FIRE_AND_THEFT = "CARAVAN_FIRE_AND_THEFT",
  CARAVAN_FULL_OWN_DAMAGE = "CARAVAN_FULL_OWN_DAMAGE",
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1 = "CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_1",
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_2 = "CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_2",
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_3 = "CARAVAN_FULL_OWN_DAMAGE_EXTENDED_MOVABLES_3",
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE = "CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE",
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_1 = "CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_1",
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_2 = "CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_2",
  CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_3 = "CARAVAN_FULL_OWN_DAMAGE_EXTENDED_PERMANENT_PLACE_MOVABLES_3",
  CARAVAN_SUPER = "CARAVAN_SUPER",
}

export enum ChildCoverage {
  BASIC = "NEWCHILD_BASIC",
  EXTRA = "NEWCHILD_EXTRA",
  EXTRA_HALF_G = "NEWCHILD_EXTRA_HALF_G",
  TOTAL = "NEWCHILD_TOTAL",
}

export enum ChildHealthCoverage {
  CHILD_HEALTH_TREATMENT = "CHILD_HEALTH_TREATMENT",
}

export enum CriticalIllnessCoverage {
  CRITICAL_ILLNESS_NOT_SMOKER = "CRITICAL_ILLNESS_NOT_SMOKER",
  CRITICAL_ILLNESS_SMOKER = "CRITICAL_ILLNESS_SMOKER",
}

export enum DisabilityCoverage {
  DISABILITY_FLEX = "DISABILITY_FLEX",
}

export enum DisabilityCompositions {
  DISABILITY_CAPITAL_FLEX = "DISABILITY_CAPITAL_FLEX",
  DISABILITY_PENSION = "DISABILITY_PENSION",
  DISABILITY_PENSION_3MONTHS = "DISABILITY_PENSION_3MONTHS",
}

export enum DeathCoverage {
  DEATH_NOT_SMOKER = "DEATH_NOT_SMOKER",
  DEATH_SMOKER = "DEATH_SMOKER",
}

export enum ElectricScooterCoverage {
  ELECTRIC_SCOOTER_LIABILITY_WITH_ACCIDENT = "ELECTRIC_SCOOTER_LIABILITY_WITH_ACCIDENT",
  ELECTRIC_SCOOTER_LIABILITY = "ELECTRIC_SCOOTER_LIABILITY",
  ELECTRIC_SCOOTER_REDUCED_OWN_DAMAGE_WITH_ACCIDENT = "ELECTRIC_SCOOTER_REDUCED_OWN_DAMAGE_WITH_ACCIDENT",
  ELECTRIC_SCOOTER_REDUCED_OWN_DAMAGE = "ELECTRIC_SCOOTER_REDUCED_OWN_DAMAGE",
  ELECTRIC_SCOOTER_FULL_OWN_DAMAGE_WITH_ACCIDENT = "ELECTRIC_SCOOTER_FULL_OWN_DAMAGE_WITH_ACCIDENT",
  ELECTRIC_SCOOTER_FULL_OWN_DAMAGE = "ELECTRIC_SCOOTER_FULL_OWN_DAMAGE",
}

export enum HealthCoverage {
  HEALTH_BASIS = "HEALTH_BASIS",
  HEALTH_PLUS = "HEALTH_PLUS",
  HEALTH_TOP = "HEALTH_TOP",
}

export enum HouseContentsCoverage {
  HOUSE_CONTENTS_EXTENDED = "HOUSE_CONTENTS_STANDARD_EXTENDED",
  HOUSE_CONTENTS_STANDARD = "HOUSE_CONTENTS_STANDARD",
}

export enum HouseCoverage {
  HOUSE_EXTENDED = "HOUSE_EXTENDED",
  HOUSE_STANDARD = "HOUSE_STANDARD",
}

export enum HuseierneHouseContentsCoverage {
  HUSEIERNE_HOUSE_CONTENTS_SUPER = "HUSEIERNE_HOUSE_CONTENTS_SUPER",
}

export enum PregnantAndNewbornCoverage {
  PREGNANT = "PREGNANT",
  PREGNANT_MULTIPLE_CHILDREN = "PREGNANT_MULTIPLE_CHILDREN",
  NEWBORN = "NEWBORN",
  NEWBORN_MULTIPLE_CHILDREN = "NEWBORN_MULTIPLE_CHILDREN",
}

export enum RentalCoverage {
  RENTAL = "RENTAL",
}

export enum SopSicknessLeaveCoverage {
  SOP_SICKNESS_LEAVE = "SOPSICKNESSLEAVE",
}

export enum TractorCoverage {
  TRACTOR_FULL_OWN_DAMAGE = "TRACTOR_FULL_OWN_DAMAGE",
  TRACTOR_FIRE_AND_THEFT = "TRACTOR_FIRE_AND_THEFT",
  TRACTOR_LIABILITY = "TRACTOR_LIABILITY",
}

export enum TrailerCoverage {
  TRAILER_FULL_OWN_DAMAGE = "TRAILER_FULL_OWN_DAMAGE",
  TRAILER_FIRE_AND_THEFT = "TRAILER_FIRE_AND_THEFT",
}

export enum TravelCoverage {
  TRAVEL_STANDARD = "TRAVEL_STANDARD",
  TRAVEL_COVERAGE_FOR_INSURED_ONLY = "TRAVEL_COVERAGE_FOR_INSURED_ONLY",
  TRAVEL_SUPER = "TRAVEL_SUPER",
  TRAVEL_SUPER_90_DAYS = "TRAVEL_SUPER_90_DAYS",
  TRAVEL_SUPER_120_DAYS = "TRAVEL_SUPER_120_DAYS",
  TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY = "TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY",
  TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY_90_DAYS = "TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY_90_DAYS",
  TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY_120_DAYS = "TRAVEL_SUPER_COVERAGE_FOR_INSURED_ONLY_120_DAYS",
}

export enum ValuablesCoverage {
  VALUABLES = "VALUABLES",
}

export enum VeteranAutoCoverage {
  VETERAN_AUTO_FULL_OWN_DAMAGE = "VETERAN_AUTO_FULL_OWN_DAMAGE",
  VETERAN_AUTO_REDUCED_OWN_DAMAGE = "VETERAN_AUTO_REDUCED_OWN_DAMAGE",
}

export enum MopedCoverage {
  MOPED_DRIVER_AND_PASSENGER_ACCIDENT = "MOPED_DRIVER_AND_PASSENGER_ACCIDENT",
  MOPED_REDUCED_OWN_DAMAGE = "MOPED_REDUCED_OWN_DAMAGE",
  MOPED_FULL_OWN_DAMAGE = "MOPED_FULL_OWN_DAMAGE",
}

export enum MotorcycleCoverage {
  MOTORCYCLE_DRIVER_AND_PASSENGER_ACCIDENT = "MOTORCYCLE_DRIVER_AND_PASSENGER_ACCIDENT",
  MOTORCYCLE_REDUCED_OWN_DAMAGE = "MOTORCYCLE_REDUCED_OWN_DAMAGE",
  MOTORCYCLE_FULL_OWN_DAMAGE = "MOTORCYCLE_FULL_OWN_DAMAGE",
}

export type InsuranceCoverage =
  | AccidentCoverage
  | AkaChildCoverage
  | AkaCriticalIllness
  | AkaFamilyAccidentCoverage
  | AkaGroupLifeCoverage
  | AkaHealthCoverage
  | AkaHouseContentsCoverage
  | AkaStudentCoverage
  | AkaTravelCoverage
  | AnimalCoverage
  | AnimalCoverageGroup
  | BoatCoverage
  | CabinContentsCoverage
  | CabinCoverage
  | CarCoverage
  | CaravanCoverage
  | ChildCoverage
  | ChildHealthCoverage
  | CriticalIllnessCoverage
  | DeathCoverage
  | DisabilityCoverage
  | ElectricScooterCoverage
  | HealthCoverage
  | HouseContentsCoverage
  | HouseCoverage
  | HuseierneHouseContentsCoverage
  | MopedCoverage
  | MotorcycleCoverage
  | PregnantAndNewbornCoverage
  | RentalCoverage
  | SopSicknessLeaveCoverage
  | TractorCoverage
  | TrailerCoverage
  | TravelCoverage
  | ValuablesCoverage
  | VeteranAutoCoverage;

export enum SpecialInsuranceCoverage {
  AKA_STUDENT_TRAVEL = "AKA_STUDENT_TRAVEL",
  AKA_STUDENT_HOUSE_CONTENTS = "AKA_STUDENT_HOUSE_CONTENTS",
  AKA_GROUP_LIFE_DEATH = "AKA_GROUP_LIFE_DEATH",
  AKA_GROUP_LIFE_INCAP = "AKA_GROUP_LIFE_INCAP",
}

export const OPTIONAL_COVERAGE_VALUE = "valgfritt";
type OptionalCoverageValue = typeof OPTIONAL_COVERAGE_VALUE;
type CoverageIncluded = boolean | OptionalCoverageValue;

type IsCoveragesIncludedInformation = Partial<
  Record<InsuranceType, CoverageIncluded>
>;

export interface CoverageTexts extends IsCoveragesIncludedInformation {
  caption: TranslatedText;
  explanation: TranslatedTextList;
  optional?: boolean;
  isNumber?: boolean;
}
